import {
  GET_MESSAGES,
  MESSAGE_CHANGE,
  REQUEST_LOADED,
  LOAD_USER,
  REQUEST_PET_LOADED,
  PRELOAD_REQUEST,
  ADD_MESSAGE,
  UPDATE_REQUEST
} from '../../actions';

const messagesReducer = (
  oldState = {
    messageVm: {
      requestMap: new Map(),
      petsMap: new Map(),
      conversationPartners: new Map(),
      messages: []
    }
  },
  action
) => {
  const { messageVm } = oldState;
  switch (action.type) {
    case GET_MESSAGES: {
      const { messagesFrom, messagesTo } = action;
      const messages = [
        ...messagesFrom.map(x => ({ ...x.data(), id: x.id })),
        ...messagesTo.map(x => ({ ...x.data(), id: x.id }))
      ].sort((a, b) => new Date(a.date) - new Date(b.date));
      return {
        ...oldState,
        messageVm: {
          ...messageVm,
          messages
        }
      };
    }
    case ADD_MESSAGE: {
      const { newMessage } = action;
      return {
        ...oldState,
        messageVm: {
          ...messageVm,
          message: '',
          messages: [...messageVm.messages, newMessage]
        }
      };
    }
    case PRELOAD_REQUEST: {
      const { requestMap } = action;

      return {
        ...oldState,
        messageVm: {
          ...messageVm,
          requestMap: new Map(messageVm.requestMap, requestMap)
        }
      };
    }
    case UPDATE_REQUEST: {
      const { response, key } = action;
      const oldValue = messageVm.requestMap.get(key);

      return {
        ...oldState,
        messageVm: {
          ...messageVm,
          requestMap: new Map(messageVm.requestMap.set(key, { ...oldValue, ...response }))
        }
      };
    }
    case LOAD_USER: {
      const { response, key } = action;
      return {
        ...oldState,
        messageVm: {
          ...messageVm,
          conversationPartners: new Map(messageVm.conversationPartners.set(key, response))
        }
      };
    }
    case REQUEST_LOADED: {
      const { response, key } = action;

      return {
        ...oldState,
        messageVm: {
          ...messageVm,
          requestMap: new Map(messageVm.requestMap.set(key, response))
        }
      };
    }
    case REQUEST_PET_LOADED: {
      const { response, key } = action;

      return {
        ...oldState,
        messageVm: {
          ...messageVm,
          petsMap: new Map(messageVm.petsMap.set(key, response))
        }
      };
    }
    case MESSAGE_CHANGE: {
      const { value, name } = action;
      return {
        ...oldState,
        messageVm: {
          ...messageVm,
          [name]: value
        }
      };
    }
    default:
      return oldState;
  }
};

export default messagesReducer;



// WEBPACK FOOTER //
// ./src/pages/Messages/messagesReducer.js